import React from 'react';
import { isSafelyInitializedWithLayout } from '../../utils/commonHelper';
import PropTypes from 'prop-types';
import FooterFlexible from '../FooterFlexible';

const BottomFooter = ({isSrp, isLoading}) => {
  const isMobile = isSafelyInitializedWithLayout('mobile');
  const display = (!isMobile || (isMobile && !isSrp) || (isMobile && isSrp && !isLoading));
  if (!display) {
    return null;
  }
  return <FooterFlexible />;
};

BottomFooter.propTypes = {
  isSrp: PropTypes.bool,
  isLoading: PropTypes.bool
};

export { BottomFooter };
